import React, { Component } from 'react';
import { arrayOf, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import SafePureComponent from '../shared/SafePureComponent';
import { validateDescription } from '../../utils/mainComponentsValidator';
import { sanitize } from '../../utils/sanitization';
import { BQ_GIG_DESCRIPTION_SEE_MORE } from '../../utils/bigQueryEvents';
import Metadata from './Metadata';

import './style.scss';

const createMarkup = (data) => data ? { __html: data } : null;

class Description extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showInfo: false
        };

        this.toggleCollapsed = this.toggleCollapsed.bind(this);
    }

    toggleCollapsed(event) {
        event.preventDefault();

        const { showInfo } = this.state;

        this.setState({
            showInfo: !showInfo
        });

        if (!showInfo) {
            this.reportShowInfoEvent();
        }
    }

    reportShowInfoEvent() {
        const { biEvents } = this.context;

        biEvents.sendBigQueryEvent({ eventName: BQ_GIG_DESCRIPTION_SEE_MORE });
    }

    render() {
        const { description } = this.props;

        // todo: maintain error
        if (!validateDescription({ description, error: false })) {
            return null;
        }

        const showContent = classNames('description-content', { 'show': this.state.showInfo });
        const { metadataAttributes, content } = description;
        const sanitizedContent = createMarkup(sanitize(content));
        const showKey = this.state.showInfo ? 'see_less' : 'see_more';

        return (
            <div className="gig-description">
                <header>
                    <h2 className="section-title"><I18n k={'gig_page_perseus.description.title'}/></h2>
                </header>
                {sanitizedContent &&
                <div className="description-wrapper">
                    <div className={showContent} dangerouslySetInnerHTML={sanitizedContent}/>
                    <div className="cover"/>
                    <a href="#!" className="collapse-button" onClick={this.toggleCollapsed}>
                        <I18n k={`gig_page_perseus.description.${showKey}`}/>
                    </a>
                </div>
                }
                {metadataAttributes && <Metadata metadataAttributes={metadataAttributes}/>}
            </div>
        );
    }
}

Description.propTypes = {
    description: shape({
        content: string,
        metadataAttributes: arrayOf(
            shape({
                name: string,
                options: arrayOf(string)
            })
        )
    })
};

Description.contextTypes = {
    biEvents: object
};

export { Description };
export default SafePureComponent(Description);
